import AES from 'crypto-js/aes'
import encUtf8 from 'crypto-js/enc-utf8'
import { login } from '../../system/environment/Config.json'
const { encKey } = login

export class CryptoUtil {
  static readonly encrypt = (message: string) => {
    const encrypted = AES.encrypt(message, encKey)
    return encrypted.toString()
  }

  static readonly decrypt = (ciphertext: string) => {
    if (ciphertext) {
      const bytes = AES.decrypt(ciphertext, encKey)
      const decryptedData = bytes.toString(encUtf8)
      return decryptedData
    }
    return ciphertext
  }

  static readonly rsaEncryptWithJwk = async (plaintext: string, jwk: JsonWebKey): Promise<string> => {
    const cryptoKey = await window.crypto.subtle.importKey('jwk', jwk, { name: 'RSA-OAEP', hash: 'SHA-256' }, false, [
      'encrypt'
    ])

    const encoded = new TextEncoder().encode(plaintext)
    const encrypted = await window.crypto.subtle.encrypt({ name: 'RSA-OAEP' }, cryptoKey, encoded)

    return btoa(String.fromCharCode(...new Uint8Array(encrypted)))
  }
}
